import axios from 'axios';

export const api = axios.create({
    withCredentials: false,
    baseURL: `${process.env.GATSBY_BACKEND_URL}/api/v2`,
})
